import { isPastClose, formatWindowDate } from '@/shared/utils/deadline';

export const STUDENT_WINDOWS_CLOSED =
    'Student applications are closed for this term.';

/**
 * Whether students may start or change an application to a program this
 * term. The server decides and sends it on the current term as
 * `studentApplicationWindows`; the only thing worked out here is a close that
 * passed since the page loaded. A term that carries no verdict (an older
 * term, or one that has not loaded) is treated as open, and the server's
 * refusal is shown if it is not.
 *
 * @param {object|null} term - The current term.
 * @param {string} program - 'si' | 'ta' | 'la'
 * @param {Date} [now]
 * @returns {{ accepting: boolean, closeDate: string|null, message: string|null }}
 */
export function studentWindowFor(term, program, now = new Date()) {
    const verdict = term?.studentApplicationWindows?.[program];
    if (!verdict) return { accepting: true, closeDate: null, message: null };
    const passed =
        Boolean(verdict.closeDate) && isPastClose(verdict.closeDate, now);
    return {
        accepting: verdict.accepting && !passed,
        closeDate: verdict.closeDate || null,
        message: verdict.message,
    };
}

/** Close dates of the open programs, as one line each distinct date. */
export function closeLines(term, programs, now = new Date()) {
    const byDate = new Map();
    for (const program of programs) {
        const window = studentWindowFor(term, program, now);
        if (!window.accepting || !window.closeDate) continue;
        const label = formatWindowDate(window.closeDate);
        byDate.set(label, [...(byDate.get(label) || []), program]);
    }
    return [...byDate.entries()].map(([date, list]) => ({
        date,
        programs: list,
    }));
}
